import React, { useState } from "react";
import { TopBanner } from "./TopBanner";
import { MenuToggle } from "./components/MenuToggle";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { buildCreateAccountBreadcrumb } from "./breadcrumbs";
import { Routes, Route } from "react-router-dom";
import { CreateAccountMenu } from "./components/CreateAccountMenu";
import { CreateAccountWizard } from "./components/account/CreateAccountWizard";
import { CustomerCountryService } from "./services";

export const CreateAccount: React.FC = () => {

    const [currentStep, setCurrentStep] = useState(1);
    const [maxStep, setMaxStep] = useState(1);
    const [hasExistingAccounts, setHasExistingAccounts] = useState<boolean | null>(null);
    const [isNavigationVisible, setNavigationVisible] = useState(false);
    const toggleNavigation = () => setNavigationVisible(!isNavigationVisible);
    const breadcrumbItems = buildCreateAccountBreadcrumb();

    return (
        <ErrorBoundary>
            <div className="main">
                <div className="container">

                    {/* LEFT NAVIGATION */}
                    <div className={`navigation ${isNavigationVisible ? 'show' : ''}`}>
                        <CreateAccountMenu
                            currentStep={currentStep}
                            maxStep={maxStep}
                            hasExistingAccounts={hasExistingAccounts}
                            onCloseMenu={() => setNavigationVisible(false)}
                        />
                    </div>

                    {/* BACKDROP */}
                    <div
                        className={`nav-backdrop ${isNavigationVisible ? 'show' : ''}`}
                        onClick={toggleNavigation}
                        aria-hidden={!isNavigationVisible}
                    />

                    {/* RIGHT CONTENT AREA */}
                    <div className="right-area">

                        <div className="top-banner">
                            <MenuToggle onToggleNavigation={toggleNavigation} />
                            <TopBanner breadcrumbItems={breadcrumbItems} />
                        </div>

                        <div className="content">
                            <Routes>

                                <Route
                                    path="/"
                                    element={
                                        <>
                                            <CreateAccountWizard
                                                onStepChange={(step, max, hasExisting) => {
                                                    setCurrentStep(step);
                                                    setMaxStep(max);
                                                    setHasExistingAccounts(hasExisting);
                                                }}
                                            />
                                        </>
                                    }
                                />

                            </Routes>
                        </div>

                    </div>

                </div>
            </div>
        </ErrorBoundary>
    );
};